// Drop-in replacement for the Claude-artifact `window.storage` API, backed by
// real browser localStorage so the app works as a standalone site.
// Same shape (get/set/delete returning { key, value }) so App.jsx barely changed.

export const storage = {
  async get(key) {
    const raw = localStorage.getItem(key);
    if (raw === null) return null;
    return { key, value: raw };
  },
  async set(key, value) {
    localStorage.setItem(key, value);
    return { key, value };
  },
  async delete(key) {
    localStorage.removeItem(key);
    return { key, deleted: true };
  },
};
